import React, { useState } from 'react';
import { Box, Paper } from '@mui/material';

import { Loading } from 'components/loading';
import { useBuildingTree } from 'pages/dashboard/visualization.context.hook';
import { BuildingTreeBuildingItem, BuildingTreeFloorItem } from '.';

export const BuildingTree = () => {
  const [{ loading, building, floors }] = useBuildingTree();
  const [visibleFloors, setVisibleFloors] = useState<boolean>(false);

  return loading ? (
    <Paper>
      <Loading text="Loading building..." height={428} />
    </Paper>
  ) : (
    <Box>
      {building ? (
        <BuildingTreeBuildingItem
          building={building}
          visibleFloors={visibleFloors}
          setVisibleFloors={setVisibleFloors}
        />
      ) : (
        <Box>No building</Box>
      )}

      {visibleFloors ? (
        floors ? (
          <>
            {Array.from(floors, ([floorId, floor]) => (
              <BuildingTreeFloorItem key={`floor-${floorId}`} floor={floor} />
            ))}
          </>
        ) : (
          <Box>No floors</Box>
        )
      ) : null}
    </Box>
  );
};
